var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookGroup = function SvgFacebookGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "data-name": "Group 4265",
    viewBox: "0 0 25 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1f99f9",
    d: "M17.229 9.717a2.572 2.572 0 0 0 1.049.13 4.333 4.333 0 1 0 0-8.666h-.263A6.244 6.244 0 0 1 19.2 4.989a6.655 6.655 0 0 1-1.971 4.728",
    "data-name": "Path 18939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f99f9",
    d: "M19.994 11.334h-.921a7.218 7.218 0 0 1 2.764 5.777 6.577 6.577 0 0 1-.264 1.58 10.684 10.684 0 0 0 2.632-.788 1.718 1.718 0 0 0 .79-1.576 4.911 4.911 0 0 0-5.001-4.993",
    "data-name": "Path 18940"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f99f9",
    d: "M6.712 9.847a2.9 2.9 0 0 0 1.053-.128 7.066 7.066 0 0 1-1.971-4.861A6.245 6.245 0 0 1 6.975 1.05h-.263a4.4 4.4 0 0 0 0 8.8Z",
    "data-name": "Path 18941"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f99f9",
    d: "M5.791 11.334H5a4.993 4.993 0 0 0-5 4.989 1.718 1.718 0 0 0 .79 1.576 6.942 6.942 0 0 0 2.632.788 6.575 6.575 0 0 1-.263-1.576 7.486 7.486 0 0 1 2.632-5.777",
    "data-name": "Path 18942"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f99f9",
    d: "M9.472 8.666a4.887 4.887 0 0 0 6.054 0 4.664 4.664 0 0 0 1.843-3.808 4.467 4.467 0 0 0-1.185-3.151A4.9 4.9 0 0 0 12.499 0a4.7 4.7 0 0 0-3.685 1.707 4.58 4.58 0 0 0-1.317 3.151 4.783 4.783 0 0 0 1.975 3.808",
    "data-name": "Path 18943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f99f9",
    d: "M15.077 11.597H9.65a5.609 5.609 0 0 0-4.781 5.515 1.891 1.891 0 0 0 .9 1.707c.9.525 2.713 1.182 6.46 1.182s5.556-.657 6.46-1.182a1.922 1.922 0 0 0 .9-1.707 5.081 5.081 0 0 0-4.512-5.515",
    "data-name": "Path 18944"
  })));
};
export default SvgFacebookGroup;